import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import DocumentHead from 'legacyComponents/documentHead';
import { FourOhFour } from 'apps/fourOhFour/index';
import { TopBar } from 'legacyComponents/layout/topBar';
import { Tags } from 'apps/tag/index';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { Collections } from 'icons';
import { imageSrc } from 'apps/file/utils';
import { EmptyWrapper, EmptyText } from 'components';
import Header from 'apps/components/header/header';
import { conf as mainConf } from 'apps/config.yaml';

import {
  CollectionOverview,
  CollectionOverviewIndicator,
} from 'apps/collection/views/overview';
import { Curator } from 'apps/collection/views/curator';
import { CollectionAppManager } from 'apps/collection/main/appManager';

@withNamespaces()
@inject('routerStore')
@observer
export class CollectionPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CollectionAppManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    if (this.appManager.queries.get('collection')?.notFound) {
      return <FourOhFour type='Collection' />;
    }
    const { collection } = this.appManager;
    if (collection === null && this.appManager.loading) {
      return (
        <main>
          <Header />
          <DocumentHead title={`${t('Loading...')}`} />
          <TopBar>{/* TODO: Add <TagsIndicator /> */}</TopBar>
          <CollectionOverviewIndicator />
        </main>
      );
    }

    if (!collection) {
      return (
        <EmptyWrapper className=' bg-white'>
          <Collections width='6em' height='6em' />
          <EmptyText text='No Collections to show.' />
        </EmptyWrapper>
      );
    }
    // choose te first image in the collection
    // why doesn't the collection object have Projects?
    const imagePath = imageSrc(
      collection.images.apps[0],
      '',
      mainConf.imgSizes.project.card,
    );
    const projects = this.appManager.projectsConn.arrayApp;
    return (
      <main>
        <Header />
        <DocumentHead
          title={collection.name}
          description={collection.description}
          imagePath={imagePath}
        />
        <TopBar>
          <Tags
            type='Topics'
            tags={collection.tags}
            app={collection}
            mobileCentered
          />
          <Curator collection={collection} />
        </TopBar>
        <MainWrapper>
          <CollectionOverview collection={collection} />
          <CardSection
            invisible={collection.manager.loading}
            title={t('Projects')}
            ownerName=''
            isCollection={true}
            cardApp={projects}
            CardComponent={ProjectCard}
            noDataCardType='project'
            gridColumns={3}
            last
            noSort
          />
        </MainWrapper>
      </main>
    );
  }
}

CollectionPage.propTypes = {
  t: PropTypes.func,
};
